<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/",
        "headline":"Hot Linux ／ WEBシステム開発（主なサービス）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。よくご依頼のある内容をまとめました。その他の内容でもクライアント様のご要望に合わせた形で実現可能です。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-account-wrench-outline"
          bg-color="grey-lighten-4"
          rounded
        >
          <h3>主なサービス</h3>
        </v-breadcrumbs>

        <v-card v-for='(row,index) in サービスrtn' :key='index' class='mx-3 my-3'>
          <template v-slot:title>
            <v-list>
              <v-list-item
                :href="row.サンプルpath"
                target="_blank"
                style='white-space:normal'
              >
                {{row.タイトル}}
              </v-list-item>
            </v-list>
          </template>
          <!--
          <v-card-title @click="onClickTitle()">
            {{row.タイトル}}
          </v-card-title>
          -->
          <v-card-subtitle>
            {{row.サブタイトル}}
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <template v-if="row.画像">
                  <v-img class='mx-5'
                    :src='require("/src/assets/"+row.画像)'
                  ></v-img>
                </template>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                <span v-html='row.テキスト'></span>
                </v-row>
                <v-row> 
                  <v-col class='text-right text-h5'>{{Number(row.金額).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })}}〜</v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions
          >
            <v-spacer></v-spacer>
            <v-btn
              v-if="row.詳細path"
              :href="row.詳細path"
              target='_blank'
              variant="elevated"
              color='primary'
            >詳細を見る
            </v-btn>
            <v-btn
              v-if="row.サンプルpath"
              :href="row.サンプルpath"
              target="_blank"
              variant="elevated"
              color='primary'
            >
              サンプルを見る
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LeftSide from './LeftSide.vue';
export default {
  components: { LeftSide },
  data(){
    return {
      panel:false,
      サービスrtn:[],
    }
  },
  created(){
  },
  mounted(){
    this.サービス取得();
  },
  
  methods:{
    サービス取得(){
      this.$emit('overlay');
      let url = './api/api.php';
      let data = {
        func:"サービス取得",
        pageSize:15,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.サービスrtn = result.サービスrtn;
        this.$emit('overlay');
      })
      .catch(error =>{
        console.log(error)
        alert('取得できませんでした。\n\n'+error.body);
        this.$emit('overlay');
      })
    },

    onClickSample(url){
      window.open(url);
    },

    onClickTitle(){
      alert("タイトルタップ")
    },
  },

}
</script>